import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

const javascript = `const WebSocket = require("ws");

const ws = new WebSocket("wss://<base_url>/transactionalws", {
  headers: {
    "x-access-token": "<access_token_here>"
  }
});

ws.on("open", () => console.log("Connected"));
ws.on("close", () => console.log("Closed"));
ws.on("message", (data) => console.log("Message:", data.toString()));
ws.on("error", (err) => console.log("Error:", err.message));`;

const python = `import websocket

url = "wss://<base_url>/transactionalws"
token = "<access_token_here>"

headers = [
    f"x-access-token: {token}"
]

def on_open(ws):
    print("Connected")

def on_close(ws, close_status_code, close_msg):
    print("Closed", close_status_code, close_msg)

def on_message(ws, message):
    print("Message:", message)

def on_error(ws, error):
    print("Error:", error)

ws = websocket.WebSocketApp(
    url,
    header=headers,
    on_open=on_open,
    on_close=on_close,
    on_message=on_message,
    on_error=on_error
)

ws.run_forever()`;

const cookieBased = `<script>
  // Consider the backend previously has set the 'access_token' cookie already by the login/token endpoint response, via HTTPS OR you set it (if not HttpOnly):
  // document.cookie = "access_token=YOUR_TOKEN; path=/; secure; samesite=none";
  // Browser-based WebSocket clients send cookies automatically.

  const ws = new WebSocket("wss://<base_url>/transactionalws");

  ws.onopen = () => console.log("Connected");
  ws.onclose = () => console.log("Closed");
  ws.onmessage = (e) => console.log("Message:", e.data);
  ws.onerror = (e) => console.log("Error:", e);

  // Cookies for the same domain are sent automatically in WS handshake.
</script>`;

function CodeBlock({ code, language }) {
  return (
    <Highlight {...defaultProps} theme={theme} code={code} language={language}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}

function EFDAAF() {
  return (
    <>
      <CodeBlock code={javascript} language="javascript" />
      <p style={{ fontWeight: "600", marginTop: "16px", marginBottom: "4px", color: "rgba(0,0,0,0.87)" }}>Python Client</p>
      <CodeBlock code={python} language="python" />
      <p style={{ fontWeight: "600", marginTop: "16px", marginBottom: "4px", color: "rgba(0,0,0,0.87)" }}>Sample Code (Cookie-Based Auth — Browser Clients)</p>
      <CodeBlock code={cookieBased} language="markup" />
    </>
  );
}
export default EFDAAF;
